module.exports = __webpack_public_path__ + "p1_img1.jpg?8db35106256db9d54301619b0f2efe25";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img1.jpg
// module id = 103
// module chunks = 0